module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.448c34a5.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
 ** module id = 1598
 ** module chunks = 0
 **/